import { CheckCircleSolid, ClockCircleSolid, DangerCircleSolid, DangerTriangleSolid } from '@mynaui/icons-react';
import { Loader2 } from 'lucide-react';

import { ProcessJobStatus } from '@/graphql/graphql';
import type { RunDisplayStatus } from '@/lib/analyses/mergeRuns';

/** One icon per status — distinct shapes, never colour alone. `PARTIAL` is a
 *  paired comparison where one part failed (amber triangle). */
export function RunStatusIcon({ status }: { status: RunDisplayStatus }) {
  if (status === 'PARTIAL') return <DangerTriangleSolid className='size-5 text-amber-500' />;
  if (status === ProcessJobStatus.Processing) return <Loader2 className='size-5 animate-spin text-blue-600' />;
  if (status === ProcessJobStatus.Processed) return <CheckCircleSolid className='size-5 text-emerald-500' />;
  if (status === ProcessJobStatus.Failed) return <DangerCircleSolid className='size-5 text-rose-500' />;
  return <ClockCircleSolid className='size-5 text-amber-500' />;
}
